import styled from 'styled-components';
export const TitleContainer = styled.div `
    margin-bottom: 32px;
`;
export const PlayerResponsiveContainer = styled.div `
    position: relative;
    width: 100%;
    padding-bottom: ${(props) => props.aspect || '56.25%'};
    height: 0;
    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;

        height: 100%;
    }
`;
export const ImageContainerWrapper = styled.div `
    position: relative;
    padding-bottom: 75%; // 4:3
`;
export const ImageContainer = styled.div `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-image: url(${(props) => props.$image});
    background-size: cover;
    background-position: center;
`;
